module.exports = __webpack_public_path__ + "static/media/bordeQueso.031d2cfc.jpg";